import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/common/Button';
import { listWorkflowStages, listWorkflowTemplates, type WorkflowStage, type WorkflowTemplateRow } from '../../services/workflow';

type Unit = 'Days' | 'Hours';

export default function KpiConfigurationPage() {
  const { t } = useTranslation();
  const templates = listWorkflowTemplates();
  const [templateId, setTemplateId] = useState(templates[0]?.id ?? '');

  const stages = useMemo(() => listWorkflowStages(templateId), [templateId]);
  const [stageId, setStageId] = useState(stages[0]?.id ?? '');

  const [ttc, setTtc] = useState('14');
  const [ttr, setTtr] = useState('12');
  const [tte, setTte] = useState('16');
  const [ttcUnit, setTtcUnit] = useState<Unit>('Days');
  const [ttrUnit, setTtrUnit] = useState<Unit>('Days');
  const [tteUnit, setTteUnit] = useState<Unit>('Days');

  const selectedTemplate: WorkflowTemplateRow | undefined = templates.find((t) => t.id === templateId);
  const selectedStage: WorkflowStage | undefined = stages.find((s) => s.id === stageId);

  return (
    <>
      <div className="bc">
        <span>{t('workflow.management')}</span>
        <span className="bc-sep">/</span>{t('workflow.kpi.breadcrumb')}
      </div>

      <div className="page-hdr" style={{ marginBottom: 12 }}>
        <div>
          <div className="pg-title" style={{ marginBottom: 0 }}>
            {t('workflow.kpi.title')}
          </div>
        </div>
      </div>

      <div className="al-filter" style={{ marginBottom: 14 }}>
        <div className="al-filter-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="al-f">
            <div className="al-l">{t('workflow.kpi.workflowTemplateName')}</div>
            <input className="al-inp" value={selectedTemplate?.name ?? ''} readOnly />
          </div>
          <div className="al-f">
            <div className="al-l">{t('workflow.kpi.workflowStage')}</div>
            <input className="al-inp" value={selectedStage?.code ?? selectedStage?.label ?? ''} readOnly />
          </div>
        </div>
      </div>

      <div className="al-filter">
        <div className="al-filter-title" style={{ marginBottom: 10 }}>
          {t('workflow.kpi.kpisTitle')}
        </div>

        <div className="kpi-grid">
          <div className="kpi-field">
            <div className="kpi-l">
              {t('workflow.kpi.timeToComplete')} <span className="req">*</span>
            </div>
            <div className="kpi-inp">
              <input className="kpi-num" value={ttc} onChange={(e) => setTtc(e.target.value)} />
              <select className="kpi-unit" value={ttcUnit} onChange={(e) => setTtcUnit(e.target.value as Unit)}>
                <option value="Days">{t('workflow.kpi.days')}</option>
                <option value="Hours">{t('workflow.kpi.hours')}</option>
              </select>
            </div>
          </div>
          <div className="kpi-field">
            <div className="kpi-l">
              {t('workflow.kpi.timeToRemind')} <span className="req">*</span>
            </div>
            <div className="kpi-inp">
              <input className="kpi-num" value={ttr} onChange={(e) => setTtr(e.target.value)} />
              <select className="kpi-unit" value={ttrUnit} onChange={(e) => setTtrUnit(e.target.value as Unit)}>
                <option value="Days">{t('workflow.kpi.days')}</option>
                <option value="Hours">{t('workflow.kpi.hours')}</option>
              </select>
            </div>
          </div>
          <div className="kpi-field">
            <div className="kpi-l">
              {t('workflow.kpi.timeToEscalate')} <span className="req">*</span>
            </div>
            <div className="kpi-inp">
              <input className="kpi-num" value={tte} onChange={(e) => setTte(e.target.value)} />
              <select className="kpi-unit" value={tteUnit} onChange={(e) => setTteUnit(e.target.value as Unit)}>
                <option value="Days">{t('workflow.kpi.days')}</option>
                <option value="Hours">{t('workflow.kpi.hours')}</option>
              </select>
            </div>
          </div>
        </div>

        <div className="al-filter-actions">
          <Button onClick={() => null}>{t('common.cancel')}</Button>
          <Button variant="primary" onClick={() => null}>{t('common.save')}</Button>
        </div>
      </div>
    </>
  );
}
